var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-modal',{ref:"modal",attrs:{"id":"plug-modal","title":"","hide-footer":"","hide-header":"","centered":"","no-close-on-backdrop":""}},[_c('div',{staticClass:"header"},[_c('h3',[_vm._v(" Акция завершена ")])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }